var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65.42 43.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:#00322e;}.h{fill:#fff;filter:url(#b);}.i{filter:url(#e);}"), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "c",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "f",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "f",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M30.73,37.95c-8.58,0-13.95-4.22-14-11.02v-1.77l9.6-1.27,.92-5.37-8.36-1.51,.27-1.91c.89-6.3,6.07-9.92,14.22-9.92s12.8,3.78,12.8,9.64c0,2.09-.63,4.76-3.26,6.81,1.24,1.5,1.9,3.42,1.9,5.63,0,6.59-5.39,10.68-14.08,10.68Zm-.64-11.44c0,.54,.12,.83,.21,.92,.07,.07,.28,.12,.55,.12,.43,0,.64,0,.64-.76,0-.13-.02-.2-.03-.22h0s-.16-.06-.45-.06h-.92Zm2.08-10.56c.56,0,.82-.12,.87-.16h0s.01-.07,.01-.2c0-.06,0-.11,0-.15-.04,0-.11-.01-.19-.01-.33,0-.59,0-.73,.52h.05Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M42.81,27.27c0,6-5.32,8.68-12.08,8.68-7.68,0-11.96-3.52-12-9.04l9.4-1.24c-.24,2.32,.56,3.88,2.72,3.88,1.6,0,2.64-.96,2.64-2.76,0-1.44-.96-2.28-2.48-2.28h-2.76l1.12-6.56h2.8c1.68,0,2.88-.72,2.88-2.36,0-1.44-.88-2.16-2.2-2.16-2.08,0-2.8,1.4-2.84,3.56l-8.88-1.6c.8-5.68,5.68-8.2,12.24-8.2s10.8,2.68,10.8,7.64c0,3.4-1.96,5.36-4.76,6.52,2.32,1.24,3.4,3.36,3.4,5.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg31);
export default __webpack_public_path__ + "static/media/3_1.065a03bcd4f5244d5e969328b6da6399.svg";
export { ForwardRef as ReactComponent };